import { Avatar, Box, Button, Flex, Image, Text } from "@chakra-ui/react";

export const formatTableValue = (value, key, submit, id) => {
  switch (key) {
    case "employeeFullName":
      return (
        <Text onClick={() => submit(id)} cursor={"pointer"} _hover={{
          color: "#2B6CB0"
        }}>{value}</Text>
      );
    case "avatar":
      return <Avatar src={value} />;
    default:
      return <Text>{value}</Text>;
  }
};

export const formatTableValueV2 = (value, key, submit, id) => {
  switch (key) {
    case "avatar":
      return <Avatar src={value} />;
    default:
      return <Text>{value}</Text>;
  }
};